import { render, staticRenderFns } from "./self-inspection.vue?vue&type=template&id=23b17693&scoped=true&"
import script from "./self-inspection.vue?vue&type=script&lang=js&"
export * from "./self-inspection.vue?vue&type=script&lang=js&"
import style0 from "./self-inspection.vue?vue&type=style&index=0&id=23b17693&prod&lang=scss&"
import style1 from "./self-inspection.vue?vue&type=style&index=1&id=23b17693&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b17693",
  null
  
)

export default component.exports